export const CURRENCY_METRIC_TYPE = 'currency';
export const PERCENTAGE_METRIC_TYPE = 'percentage';
export const DATE_DIMENSION_TYPE = 'date';

export const TOP_X_COUNT_MAX_VALUE = 25;
export const TOP_X_THRESHOLD = 5;
